export default `query newGearItems {
  newGearItems {
    data {
      name
      sku
      discontinued
      hideprice
      typename
      url
      image_url
      regular_price
      special_price
      stock_status
    }
  }
}`;